namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.StayRecapWidget = compass.defineWidget(function StayRecapWidget(options) {
	var $j = jQuery;
	var settings = options;
	var recapArray = settings.recapArray;
	var totals = settings.totals;
	var validator = null;

	recapArray = _.map(recapArray, function(stay){
	 	if(stay.stayRecap){
	 		return stay;
	 	}
	 	else{
	 		return {stayRecap: stay};
	 	}
	 });

	var _settings = options;
	var _cf = _settings.meetingInfo.defaultCurrencyFormatter;
	var _df = _settings.meetingInfo.defaultDateFormatter;
	var _taxesMessage = "This amount includes the city's hotel tax rate. Additional fees may apply to your reservation. Please reference your confirmation for specific details.";
	var _guaranteeMessage = "By providing a credit card you guarantee you'll meet the hotel policies of your reservation. If for some reason you don't meet the policies you may be charged a financial penalty in the amount of the payment guarantee. For more info please refer to your hotel's specific policies.";
	var _depositMessage = "You will be charged a deposit for this reservation. The deposit amount is calculated based on the combination of each hotel's policies. Any changes to your reservation may be subject to additional deposit charges or cancellation fees. For more info, please refer to your hotel's specific policies.";
    var _defaultImage = compass.staticPrefix + "/resources/img/compass/hotel/nomainimage.jpg";

	var _overallRecap;

	var me = this;
	var d = jQuery.dom.getContext(this);
	var _isGDS = settings.GDS || _.any(recapArray, function (stay) { return stay.stayRecap.GDS; });

	this.validate = function() {
		this.validator.validateAll();
		return this.validator.valid;
	};

	var _setupControls = this.setupControls = function() {
	};

	var setInfo = function (data) {
		recap = data;
	};
	this.set = this.setValues = setInfo;

	var _render = this.render = function(widgetElem) {
		/*if (typeof recapArray !== 'array') {
			throw "Cannot render until data is provided.";
		}*/
		/* sometimes the data packet coming into this widget has the stay recap under .stayRecap, sometimes it doesn't*/
		/* we only do this until we standardize the data packet coming in */
		/* non-standard packet hack */
		var stayRecap = recapArray[0].stayRecap ? recapArray[0].stayRecap : recapArray[0];
		var widgetLiteClass = _settings.lite ? 'lite' : '';
		jQuery(widgetElem).addClass(widgetLiteClass);


		var stayMap = { };
		_.each(recapArray, function(s) {
			//var stayKey = s.stayRecap.check_in + '_' + s.stayRecap.check_out + '_' + s.stayRecap.room_name;
			var stayKey = s.stayRecap.blockedRoomId || s.stayRecap.roomType;
			if(stayMap[stayKey]) {
				stayMap[stayKey].rooms += Number(s.stayRecap.numRooms);
				stayMap[stayKey].nights += Number(s.stayRecap.numNights);
				stayMap[stayKey].cost += Number(s.stayRecap.totalCost);
                stayMap[stayKey].subTotal += Number(s.stayRecap.subTotal);
                stayMap[stayKey].chargedAmountTotal += (s.stayRecap.depositWillBeCharged ? Number(s.stayRecap.deposit) : 0.00) * s.stayRecap.numRooms;
                stayMap[stayKey].guaranteeTotal += (!s.stayRecap.depositWillBeCharged ? Number(s.stayRecap.deposit) : 0.00) * s.stayRecap.numRooms;
			} else {
				stayMap[stayKey] = s;
				stayMap[stayKey].rooms = Number(s.stayRecap.numRooms);
				stayMap[stayKey].nights = Number(s.stayRecap.numNights);
                stayMap[stayKey].cost = Number(s.stayRecap.totalCost);
				stayMap[stayKey].subTotal = Number(s.stayRecap.subTotal);
                stayMap[stayKey].chargedAmountTotal = (s.stayRecap.depositWillBeCharged ? Number(s.stayRecap.deposit) : 0.00) * s.stayRecap.numRooms;
                stayMap[stayKey].guaranteeTotal = (!s.stayRecap.depositWillBeCharged ? Number(s.stayRecap.deposit) : 0.00) * s.stayRecap.numRooms;
			}
		});


		var recaps = _.pluck(recapArray,'stayRecap');

		var dates = _.filter(recaps, function(e,i){
			return e.depositWillBeCharged;
		});
		
		var mindate = _.min(dates,function(e){ return Number(e.depositWillBeChargedAt.split('-').join(''));});
		/*
		dates = _.map(dates, function(e,i){
			return Number(e.split('-').join(''));
		});
		*/
		
		_overallRecap = {
			hasAnyCharging: _.some(stayMap, function(r){return (r.chargedAmountTotal > 0.00);}), 
			chargedAmount: _.reduce(stayMap, function(memo,r){return memo + Number(r.chargedAmountTotal);},0), 
			guaranteeAmount: _.reduce(stayMap, function(memo,r){return memo + Number(r.guaranteeTotal);},0),
			minChargedDate: mindate.depositWillBeChargedAt,
			hasAnyChargingToday: _.some(recaps, function(r){return (r.depositWillBeCharged && r.depositWillBeChargedTodayOrEarlier );}),
			totalServiceFeeAmount: _.reduce(recapArray, function(totalServiceFee, curRecap) {return totalServiceFee + curRecap.stayRecap.serviceFeeAmount;}, 0),
			totalPaidServiceFeesAmount: _.reduce(recapArray, function(total, curRecap) {return total + curRecap.stayRecap.paidServiceFeeAmount || 0;}, 0),
			totalPaidOrPendingServiceFeesAmount: _.reduce(recapArray, function(total, curRecap) {return total + curRecap.stayRecap.paidOrPendingServiceFeeAmount || 0;}, 0),
			totalFailedServiceFeesAmount: _.reduce(recapArray, function(total, curRecap) {return total + curRecap.stayRecap.failedServiceFeeAmount || 0;}, 0)
		};

		_overallRecap['outstandingServiceFee'] = _overallRecap.totalServiceFeeAmount - _overallRecap.totalPaidServiceFeesAmount;

		var widgetContent = d.div({ className: "multipleRoomTypes" });
		var resIndex = 0;
		for(var key in stayMap) {
			var stay = stayMap[key];
		
			if(settings.lite === false) {
				widgetContent.append(
					generateMultipleStaysHotelSummary(stay, resIndex)
				);
			}
			resIndex++;
		}

		if (settings.lite === true) {
			widgetContent.append(generateBriefStayTotal(stay));
		}

		widgetContent.append(
			generateAllAdditFees(),
			generateServiceFeeDOM(),
			generateAllTotal(),
			renderBottomSection(),
			d.div({
				className: "infoPair endingClear"
			}),
			generateFooter()
		);
		jQuery(widgetElem).append(widgetContent);

		_setupControls();
	};


	var renderBottomSection = function(){
		if ( _isGDS){
			return renderGDS();
		}
		else if(_overallRecap.hasAnyCharging){
			return renderCharging();
		}
		else if (_overallRecap.totalServiceFeeAmount > 0) {
			return renderServiceFeeChargingNoDeposit();
		} else {
			return renderNonCharging();
		}
		
	};

	var renderGDS = function(){
		return null;
	};

	var renderCharging = function(){

		var items =  [drawGap()];
		if (_overallRecap.guaranteeAmount > 0.00 ) items.push(generateAllGuarantee());
		if (_overallRecap.chargedAmount > 0.00 ) items.push(generateDeposit());
		items.push(drawOutstandingAmount());

		items[items.length-1].addClass('bold');
		return items;
	};
	
	var renderNonCharging = function(){
			return [ 
				generateChargeAmt(),
				drawGap(),
				generateAllGuarantee()
			];
	};
	
 var renderServiceFeeChargingNoDeposit = function () {
		var chargedTodayLine;
		if (_overallRecap.totalFailedServiceFeesAmount > 0) {
			chargedTodayLine = generateFailedServiceFeesTotalLine();
		} else if (_overallRecap.totalPaidOrPendingServiceFeesAmount > 0) {
			chargedTodayLine = generatePaidOrPendingServiceFeesTotalLine();
		} else {
			chargedTodayLine = generateChargeAmt();
		}
		
		return [
			chargedTodayLine,
			drawGap(),
			generateAllGuarantee()
		];
 };
	var drawGap = function(){
		return d.div({className : "gap"}, "");

	};

	var generateFooter = function() {
		var currencyText = 'All prices are in <%= currencyCode %>.';

		var hasAnyChargingToday = _settings.depositWillBeChargedTodayOrEarlier != null ? _settings.depositWillBeChargedTodayOrEarlier : _overallRecap.hasAnyChargingToday;
		var minChargedDate = _settings.depositWillBeChargedAt != null ? _settings.depositWillBeChargedAt : _overallRecap.minChargedDate;

		var thedate = minChargedDate != null && minChargedDate.length > 0 ? _df(compass.util.parse.ISODateParser(minChargedDate)) : "";

		var failedLinkHandler = function(evt){
			me.trigger("StayRecapWidget.pleaseUpdatePaymentClicked", {});
		};

		var failedCardsLink = d.a({className : 'updatePaymentLink' , onclick : failedLinkHandler }, 'Update payment&nbsp;&raquo;');

 

		var tackOnFailedCardsLink = false;

		if ( _settings.suppressChargingStatusMessages != null && _settings.suppressChargingStatusMessages){
			footerText = '';
		}
		else if (_overallRecap.hasAnyCharging && ( _settings.outstandingDeposit == null || _settings.outstandingDeposit > 0.00)) {
			if (minChargedDate.length > 0 ){
				footerText = 'Outstanding amounts will be charged <%= date_for_charging %>.';
			} else if ((_settings.chargingInfo.failedCards === false && groupHasCompanyGuarantee()) || _settings.chargingInfo.has_company_guarantee) {
				footerText = 'Outstanding amounts will be charged once payment is applied.';
			} else{
				footerText = 'We were unable to process some credit cards.&nbsp;';
				var tackOnFailedCardsLink = true;
			}
		// totalFailedServceFees might be NaN in the case of pre-booking flows, NaN compared to any number is always false
		} else if (_overallRecap.totalServiceFeeAmount > 0  && _overallRecap.totalFailedServiceFeesAmount > 0 ) {
			footerText = 'We were unable to process some credit cards.&nbsp;';
			tackOnFailedCardsLink = true;
		} else {
			footerText = '';
		}

		return d.div({ className: 'currencyInfo' },
			d.div({className :'currencyCodeText'}, 
			_.template(currencyText) ({
				currencyCode: _settings.meetingInfo.currencyCode,
			})
		),
		d.div({className :'footerText'},
			_.template(footerText) ({
				currencyCode: _settings.meetingInfo.currencyCode,
				date_for_charging: hasAnyChargingToday ? "today" : thedate
			}), (tackOnFailedCardsLink ? failedCardsLink : null))
		);
	};

	var groupHasCompanyGuarantee = function() {
		var hasCompanyGuarantee = _.any(_settings.paymentInfo, function(payMethod) {
			return payMethod.code === 'GUARANTEE';
		});
		return hasCompanyGuarantee;
	};

	var generateDottedLine = function() {
		return d.div({className : 'dottedLine'});
	};

	var generateMultipleStaysHotelSummary = function (stay, resIndex) {
	/***
	 * This generates the little header for the recap widget that shows
	 * the hotel name and room type with a little thumbnail above the
	 * recap information.
	 */
	 	var showHotelPolicy = '';
	 	var hotelPolicy = [d.a({
								'aria-owns': policiesId,
								className : 'policyLink',
								href: 'javascript:;'
							}, 'View hotel policies &raquo;').activate(
								function(evt){
									if(stay.stayRecap.blockedRoomId === undefined){
										me.trigger("StayRecapWidget.showPolicies", { 'resIndex' : resIndex, dialogId: policiesId });
									}
									else{
										me.trigger("StayRecapWidget.showPolicies", { 'blockedRoomId' : stay.stayRecap.blockedRoomId, dialogId: policiesId  });
									}
								}
							)];//Hotel Policy Link;
	 	if(settings.groupInfo){
	 		if(settings.groupInfo.hasGIN === false){
	 			showHotelPolicy = hotelPolicy;
	 		}
	 	}else if(settings.GINOn !== undefined){
		 	if((settings.GINOn && settings.rooms < settings.GINThreshold) || !settings.GINOn){
			 	showHotelPolicy = hotelPolicy;
			}
		}else if(settings.hasGIN !== undefined){
			if(!settings.hasGIN){
				showHotelPolicy = hotelPolicy;
			}
		}else{//Maybe another senerio may need the policy
			showHotelPolicy = hotelPolicy;
		}

	 	var policiesId = compass.generateId();
		var hotelSummary = d.div({className : "header"},
				d.div({className : "headerImgCntnr"},
					d.img({className : "headerImg",
						   src : stay.stayRecap.hotelThumbnail.length > 0 ? stay.stayRecap.hotelThumbnail : _defaultImage })
				),
				d.div({className : "headerCopyCntnr"},
					d.div({className : "hotelName"},stay.stayRecap.hotelName),
					d.div({className : "hotelRate"}, generateAvgStayRate(stay.stayRecap) + " | avg nightly event rate"),
					d.div({className : "roomType"}, stay.stayRecap.roomType || stay.stayRecap.roomName),
					showHotelPolicy
				),
				d.div({className : "clear"}),
                generateBriefStayTotal(stay)
			);

		return hotelSummary;
	};

	var drawInfoPair = function (name, label, info, extra) {
	/***
	 * This draws a pair of label->value for display in the
	 * stay summary recap.  This will generate a 'left-aligned'
	 * label and a 'right-aligned' value for that label, an example
	 * would be:
	 * Check-in                                Wednesday, 3/1
	 * Check-out                                  Monday, 3/6
	 */
		return d.spaced({
			left: label,
			right: info,
			className : name
		});
	};

	var generateAvgRate = function (currentRecap) {
	/***
	 * Generates the average nightly rate infoPair to be returned and drawn,
	 * TODO: add the drill-down link eventually (need to spec it)
	 *
	 * Avg Nightly Rate                               $169.00
	 */
		var
		 name = "avgRate",
		 label = "Avg Nightly Rate",
		 value = _cf(currentRecap.avgRate);

		return drawInfoPair(name, label, value);
	};

	var roomMathTotal = 0;
	var generateRoomMath = function (currentRecap) {
	/***
	 * Generates the room math infoPair to be returned and drawn
	 *
	 * 5 nights x 1 room =                             $845.00
	 */

		var
		 name = "roomMath",
		 label = "",
		 value = _cf(currentRecap.subTotal);

		label = currentRecap.numRooms + " Reservation";
		label += currentRecap.numRooms > 1 ? "s" : "";
		label += " (" + currentRecap.numNights + " Room Night";
		label += currentRecap.numNights > 1 ? "s" : "";
		label += ")";

		return drawInfoPair(name, label, value);
	};

	var roomMathBriefTotal = 0;
	var generateRoomMathBrief = function (currentRecap, numOfRooms) {
	/***
	 * Generates the room math infoPair to be returned and drawn
	 *
	 * 5 nights x 1 room =                             $845.00
	 */

		roomsText = Number(numOfRooms) + " Reservation";
		roomsText += Number(numOfRooms) > 1 ? "s" : "";

		return d.div({className:'roomCount'}, roomsText);
	};

	var generateBriefStayTotal = function (stay) {
	/***
	 * Generates the total amount infoPair to be returned and drawn
	 *
	 *  $995.13
	 */
		var name = "reservationStayBrief"
		  , label = ""
		  , value = _cf(stay.subTotal)
		  , roomsText
		  , nightsText;

		roomsText = Number(stay.rooms) + " Reservations";
		nightsText = Number(stay.nights) + " Room Nights";

		label = roomsText + "<br>(" + nightsText + ")";

		return drawInfoPair(name, label, value);
	};


	var generateAdditFees = function (currentRecap) {
	/***
	 * Generates the additional fees infoPair to be returned and drawn
	 *
	 * Taxes, Charges & Fees                             $150.13
	 */
	 var _alertId = compass.generateId();
	 var _taxesId = compass.generateId();
		var
		 name = "additionalFees",
		 label = d.div({className : "feesLabel"},
						d.div({className : "receiptInfoLabel", id : _taxesId}, "Taxes &amp; Fees"),
						d.div({
							className : "receiptInfoImg",
							role : 'button',
							'ARIA-role' : 'button',
							'ARIA-labelledby' : _taxesId,
							'ARIA-owns' : _alertId,
							tabindex : 0
						}).activate(function() {
							d.alert({
								id: _alertId,
								message: _taxesMessage,
								includeImage: false
							});
						})
				 ),
		 value = _cf(currentRecap.additFees);
		 seeAll,
		 extraInfo = null;

		if (currentRecap.additFeeBreakdown) {
			seeAll = d.a({
				className: "feesLinkWrapper"
			},
				d.span("("),
				d.a({className : "expand_info"}, "see all"),
				d.span(")")
			).activate(
				function (evt) {
					extraInfo.slideToggle(250);
				}
			);// &gt;");

			var infoPairs = [];

			for(var i=0; i<currentRecap.additFeeBreakdown.length - 1;i++) {
				infoPairs.push(drawInfoPair(name, label,
							_cf(currentRecap.additFeeBreakdown[label])));
			}

			extraInfo = d.div ({
				className: "extra_info"
			}, infoPairs);
		}

		var pair = drawInfoPair(name, label, value, seeAll);

		// if (typeof extraInfo !== 'undefined') {
			// pair = d.cgdiv({
				// cgtype: "breakdownHolder",
			// }, pair, d.cgdiv({ className: "clearingDiv" }), extraInfo);
		// }
		return pair;
	};

	var generateAllAdditFees = function() {
		var _alertId = compass.generateId();
		var _taxesId = compass.generateId();
		var name = "additionalFees"
		  , label = d.div({className : "feesLabel"},
						d.div({className : "receiptInfoLabel", id : _taxesId}, "Taxes &amp; Fees"),
						d.div({
							className : "receiptInfoImg",
							role : 'button',
							'ARIA-role' : 'button',
							'ARIA-labelledby' : _taxesId,
							'ARIA-owns' : _alertId,
							tabindex : 0
						}).activate(function() {
							d.alert({
								id: _alertId,
								message: _taxesMessage,
								includeImage: false
							});
						})
				 )
		  , value = _cf(_.foldl(recapArray, function(acc, stay) {
				return acc + Number(stay.stayRecap.additFees);
		  }, 0));

		return drawInfoPair(name, label, value);
	};

	var generateServiceFeeDOM = function () {
		var infoButtonDOM = d.div({className: 'receiptInfoImg', tabindex: 0, role: 'button'}).activate(function() {
			d.alert({message: recapArray[0].stayRecap.serviceFeeDescription, includeImage: false});
		});

		var labelDOM = d.div({className: 'serviceFeesLabel'}, 
			d.div({className: 'receiptInfoLabel'},
				"Service &amp; Technology Fee"
			),
			infoButtonDOM
		);

		if (_overallRecap.totalServiceFeeAmount > 0) {
			var valueDOM = _cf(_overallRecap.totalServiceFeeAmount);
			return drawInfoPair("serviceFees", labelDOM, valueDOM);
		} else {
			return null;
		}
	};

	var generatePaidOrPendingServiceFeesTotalLine = function() {
		var labelDOM = d.div({className: 'receiptInfoLabel'}, 'Amount Paid');
		return drawInfoPair(
			'paidOrPendingServiceFeesTotal',
			labelDOM,
			_cf(_overallRecap.totalPaidOrPendingServiceFeesAmount)
		);
	};
	
	var generateFailedServiceFeesTotalLine = function() {
		var labelDOM = d.div({className: 'receiptInfoLabel'}, 'Amount Due Today');
		return drawInfoPair(
			'failedServiceFeesTotal',
			labelDOM,
			_cf(_overallRecap.totalFailedServiceFeesAmount)
		);
	};

	var generateStayTotal = function (currentRecap) {
	/***
	 * Generates the total amount infoPair to be returned and drawn
	 *
	 * Total Amount of Stay                               $995.13
	 */
		var
		 name = "totalAmount",
		 label = "Estimated Total",
		 value = _cf(currentRecap.totalCost);

		return drawInfoPair(name, label, value);
	};

	var generateGuarantee = function (currentRecap) {
	/***
	 * Generates the amount for a reservation guarantee infoPair to be returned and drawn
	 *
	 * Reserveration Guarantee                               $215.03
	 */
	 	var _alertId = compass.generateId();
	 	var _guaranteeId = compass.generateId();
		var name = "guarantee";
		var label = d.div({className : "guaranteeLabel"},
				d.div({className : "receiptInfoLabel", id : _guaranteeId}, "Guarantee"),
				d.div({
					className : "receiptInfoImg",
					role : 'button',
					'ARIA-role' : 'button',
					'ARIA-labelledby' : _guaranteeId,
					'ARIA-owns' : '_alertId',
					tabindex : 0
				}).activate(function() {
					d.alert({
						id: _alertId,
						message: _guaranteeMessage,
						includeImage: false
					});
				})
		 );
		var value = _cf(currentRecap.guarantee);

		return drawInfoPair(name, label, value);
	};

	var generateDeposit = function() {
		var _alertId = compass.generateId();
		var _depositId = compass.generateId();
		var name = "deposit";
		var label = d.div({className : "depositLabel"},
						d.div({className : "receiptInfoLabel", id : _depositId}, "Deposit"),
						d.div({
							className : "receiptInfoImg",
							role : 'button',
							'ARIA-role' : 'button',
							'ARIA-labelledby' : _depositId,
							'ARIA-owns' : _alertId,
							tabindex : 0
						}).activate(function() {
							d.alert({
								id: _alertId,
								message: _depositMessage,
								includeImage: false
							});
						})
				 );
		var value = _cf(_overallRecap.chargedAmount);

		return drawInfoPair(name, label, value);
	};

	var doesReservationHaveGuarantee = function() {
		var value = _.foldl(recapArray, function(acc, stay) {
				return acc + Number(stay.stayRecap.guarantee * stay.stayRecap.numRooms);
			}, 0);
		return (value > 1) ? true : false;
	};

	var generateAllGuarantee = function() {
		var _alertId = compass.generateId();
		var _guaranteeId = compass.generateId();
		var name = "guarantee";
		var label = d.div({className : "guaranteeLabel"},
						d.div({className : "receiptInfoLabel", id : _guaranteeId}, "Guarantee"),
						d.div({
							className : "receiptInfoImg",
							role : 'button',
							'ARIA-role' : 'button',
							'ARIA-labelledby' : _guaranteeId,
							'ARIA-owns' : _alertId,
							tabindex : 0
						}).activate(function() {
							d.alert({
								id: _alertId,
								message: _guaranteeMessage,
								includeImage: false
							});
						})
				 );


		var value = _cf(_overallRecap.guaranteeAmount);

		return drawInfoPair(name, label, value);
	};
	
	var getEstimatedTotalValue = this.getEstimatedTotalValue = function() {
		var value = _.foldl(recapArray, function(acc, r) {
			return acc + Number(r.stayRecap.totalCost) + Number(r.stayRecap.serviceFeeAmount || 0);
		}, 0);
		
		return value;
	};

	var generateAllTotal = function () {
		var name = "allTotalAmount";
		var label = "Estimated Total";
		var value = _cf(getEstimatedTotalValue());

		return drawInfoPair(name, label, value);
	};

	var generateAvgStayRate = function(stay) {
		var totalNightCount = 0,
		    totalAmt = 0;
		totalNightCount += Number(stay.numNights);
		totalAmt += Number(stay.avgRate) * Number(stay.numNights);

		return _cf(totalAmt/totalNightCount);
	};

	var generateAllChargeAmt = function () {
	/***
	 * Generates the charged amount infoPair to be returned and drawn
	 *
	 * Amount Charged Today                                     $0.00
	 */
		var label = "Amount Charged Today for All Stays";
		var name = "chargedAmt";
		var value = _cf(_.foldl(recapArray, function(acc, r) {
			return acc + Number(r.stayRecap.chargedAmount);
		}, 0));

		return drawInfoPair(name, label, value);
	};

	var generateChargeAmt = function () {
		/***
		 * Generates the charged amount infoPair to be returned and drawn
		 *
		 * Amount Charged Today                                    $0.00
		 */

		var name = "chargedAmt";

		var value = _cf(_overallRecap.chargedAmount + _overallRecap.totalServiceFeeAmount);
		var label = "Amount Charged Today";

		return drawInfoPair(name, label, value);
	};


	var drawOutstandingAmount = function () {
		var name = "outstandingAmount";
		
		var outstandingDeposit = _settings.outstandingDeposit != null ? _settings.outstandingDeposit : _overallRecap.chargedAmount || 0;
		var outstandingServiceFee = _overallRecap.outstandingServiceFee;
		var outstandingAmount = outstandingDeposit + outstandingServiceFee;

		var value = _cf(outstandingAmount);
		var label = "Outstanding Amount";

		return drawInfoPair(name, label, value);
	};


}, {
	WUID : 'CRAP',
	widgetName : 'StayRecapWidget',
	chargingInfo: {
		has_charging: false,
	},
	imgPath : '/resources/img',
	subclass : false,
	GDS: false,
	suppressChargingStatusMessages: false,
	lite: false /*whether to show the hotel header (thumbnail, hotel info, etc. */
});

